import { render, staticRenderFns } from "./ParkingSpaceNewself.vue?vue&type=template&id=624ae58c&"
import script from "./ParkingSpaceNewself.vue?vue&type=script&lang=js&"
export * from "./ParkingSpaceNewself.vue?vue&type=script&lang=js&"
import style0 from "./ParkingSpaceNewself.vue?vue&type=style&index=0&id=624ae58c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624ae58c')) {
      api.createRecord('624ae58c', component.options)
    } else {
      api.reload('624ae58c', component.options)
    }
    module.hot.accept("./ParkingSpaceNewself.vue?vue&type=template&id=624ae58c&", function () {
      api.rerender('624ae58c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/parking-space/ParkingSpaceNewself.vue"
export default component.exports